/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIImportDocumentResultViewModel } from "../types/TutorAIImportDocumentResultViewModel.ts";
import { tutorAIDocumentStatusSchema } from "./tutorAIDocumentStatusSchema.ts";

export const tutorAIImportDocumentResultViewModelSchema = z.object({
  documentId: z.optional(
    z.number().int().describe("ID do documento que foi importado."),
  ),
  chunksGenerated: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de chunks gerados durante o processo de chunking e indexação.",
      ),
  ),
  embedTokensUsed: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de tokens consumidos pelo modelo de embedding durante a importação.",
      ),
  ),
  status: z.optional(
    z
      .lazy(() => tutorAIDocumentStatusSchema)
      .describe("1 = Pending | 2 = Imported | 3 = OutOfSync | "),
  ),
}) as unknown as ToZod<TutorAIImportDocumentResultViewModel>;
